import { Brand } from './BrandsLinks.types';

const COMPANIES_THAT_START_WITH_NUMBER_LETTER = '0-9';

export const formatBrandsBasedOnCategories = (brands: Brand[] = []) => {
  const formattedBrands = brands.reduce<Record<string, Brand[]>>(
    (accumulator, brand) => {
      let capitalizedFirstLetter = brand.manufacturer_name[0].toUpperCase();

      if (!isNaN(Number(capitalizedFirstLetter))) {
        capitalizedFirstLetter = COMPANIES_THAT_START_WITH_NUMBER_LETTER;
      }

      const entry = accumulator[capitalizedFirstLetter] || [];

      entry.push(brand);

      accumulator[capitalizedFirstLetter] = entry;

      return accumulator;
    },
    {},
  );

  Object.keys(formattedBrands).forEach((category) =>
    formattedBrands[category].sort((brand1, brand2) =>
      brand1.manufacturer_name.localeCompare(brand2.manufacturer_name),
    ),
  );

  return Object.entries(formattedBrands).sort((a, b) =>
    a[0].localeCompare(b[0]),
  );
};
